import {httpService} from "@/modules/common/services";

const getMatterPackages = async (uid, matterUid) => {
  try {
    const fetchMatterPackages = (pageIndex = 1, perPage = 100) => { return httpService.get(`platform/v1/clients/${uid}/payment/client_packages`, {matter_uid: matterUid, per_page: perPage, page: pageIndex}).then(res => res.data.client_packages); }
    let pageIndex = 1, perPage = 100;
    let matterPackcagesFullList = [], matterPackages = await fetchMatterPackages(pageIndex++, perPage);
    matterPackcagesFullList.push(...matterPackages);
    while (matterPackages.length === perPage){
      matterPackages = await fetchMatterPackages(pageIndex++, perPage);
      matterPackcagesFullList = matterPackcagesFullList.concat(matterPackages);
    }
    return {packages: matterPackcagesFullList};
  }
  catch (error) {
    return {error: error};
  }
};

const getPackages = async () => {
  const res = await httpService.get(`platform/v1/payment/packages`);
  if (res.status === "Error") {
    return {error: res.error};
  } else {
    return {packages: res.data.packages};
  }
};

export default {
  getMatterPackages,
  getPackages
}
